import { FormattedMessage, useIntl } from 'react-intl';
import BaseModalWithTitle, { BaseModalWithTitleProps } from '@/components/Modal/BaseModalWithTitle/BaseModalWithTitle';
import styles from './Report.module.scss'
import Textarea from '@/components/Primitive/Textarea/Textarea';
import { ChangeEvent, KeyboardEvent, useState } from 'react';
import Button from '@/components/Primitive/Buttons/Button/Button';

interface ReportProps extends Omit<BaseModalWithTitleProps, 'title'> {
  title?: string
  description?: string
  okBtn?: string
  cancelBtn?: string
  placeholder?: string
  onOK?: (text: string) => void
}

const Report = (
  {
    title,
    description,
    okBtn,
    cancelBtn,
    placeholder,
    onOK,
    ...props
  }: ReportProps) => {
  const { hide } = props
  const [text, setText] = useState('')
  const { formatMessage } = useIntl()

  const handleOK = () => {
    onOK?.(text)
    hide?.()
  }

  const  handleText = (e: ChangeEvent<HTMLTextAreaElement> | undefined) => {
    if (e) {
      setText(e?.target.value)
    }
  }

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      // Have Shift-Enter insert a line break instead
      if (!e.shiftKey) {
        e.preventDefault();
        handleOK()
      }
    }
  }

  return <BaseModalWithTitle
    {...props}
    title={title || formatMessage({id: 'report'})}
  >
    {description && <p className={styles.desc}>{description}</p>}
    <Textarea
      value={text}
      className={styles.text}
      minRows={1}
      maxRows={8}
      placeholder={placeholder}
      onChange={handleText}
      onKeyDown={handleKeyPress}
    />
    <div className={styles.buttons}>
      <FormattedMessage id="CONFIRM.OK">
        {txt => <Button
          view="main"
          onClick={handleOK}
        >{okBtn || txt}</Button>}
      </FormattedMessage>
      <FormattedMessage id="ACTION.CANCEL">
        {txt => <Button
          view="link"
          onClick={hide}
        >{cancelBtn || txt}</Button>}
      </FormattedMessage>
    </div>
  </BaseModalWithTitle>
}

export default Report
